require('./angular-aria');
module.exports = 'ngAria';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-aria/index.js
 ** module id = 679
 ** module chunks = 8
 **/